import { Table, Row, InfoIcon } from "../../../../api/components";
import * as React from 'react';
export default {
  Table,
  Row,
  InfoIcon,
  React
};